module.exports = __webpack_public_path__ + "static/media/offc-attract-fans.233ff641.png";